import Schema from '../../classes/index';
import {
  CONTRACT_FORM_DATA,
  CONTRACT_PFD,
  CONTRACT_IS_SIGNED,
  CONTRACT_IS_DEMUR,
  CONTRACT_IS_CREATED,
  CONTRACT_FORM_FETCH,
  TOKEN_STATUS,
  CONTRACT_LIST_CREATED,
  CONTRACT_LIST_AWAITING_SIGN,
  CONTRACT_LIST_SENDED,
  CONTRACT_LIST_VALIDATE,
  CONTRACT_LIST_AWAITING_NOTARY,
  CONTRACT_LIST_FINALIZED,
  CONTRACT_LIST_CANCELED,
  CONTRACT_LIST_OBJECTED,
  CONTRACT_LIST_ALL,
  RESET_IS_LOADED,
  CONTRACT_LIST_LOADED,
  CONTRACT_IS_LOADED,
  OBJECT_IS_REJECTED,
  OBJECT_REJECTED_FAIL,
  FAILURE,
  IS_SENT_NOTARISA,
  SAVE_IMAGES_FROM,
  CONTRACT_IS_CANCELED,
  CONTRACT_DATA,
  CONTRACT_LIST_AWAITING_VALIDATION,
  CONTRACT_ID,
  SET_PREVIEW_DATA,
  SIGNER_ROLE,
  PERSIST_PAGESIZE,
  PERSIST_ACTIVE_TAB,
  PERSIST_DATE_FILTER,
  PDF_MODIFIED,
  DRAFT_IS_SAVED,
  DRAFT_DATA,
  NOTIFICATION_CONTRACT_DATA,
  SOURCE_URL,
  SET_DOC_PRICE,
  SET_EDIT_SPINNER,
  DOMAIN_CERT,
} from './types';
import { CREATE_CONTRACT_STATUS, STATUS } from '../../config/constants/states';

const initialState = {
  contractFormData: {},
  previewData: {
    lessee: [{ phonePrefix:'+56' }],
    lessor: [{ phonePrefix:'+56' }],
    codebtor: [{ phonePrefix:'+56' }],
    parking: [],
    warehouse: [],
  },
  contract: {
    fecha: '',
    arrendador: {
      nombre: '',
    },
    arrendatario: {
      nombre: '',
    },
  },
  persistContractId: sessionStorage.getItem('contractId'),
  contractId: '',
  createdDocList: {},
  awaitingSignDocList: {},
  sendedDocList: {},
  validateForAll: {},
  awaitingNotary: {},
  awaitingValidation: {},
  finalizedDocList: {},
  canceledDocList: {},
  objectedDocList: {},
  allDocList: {},
  listIsLoaded: false,
  isLoaded: false,
  contractPdf: '',
  contractIsSigned: false,
  contractIsDemur: false,
  isCreated: CREATE_CONTRACT_STATUS.PENDING,
  tokenStatus: '',
  objIsRejected: false,
  objRejectedFail: false,
  operationFailure: false,
  contractIsSent: false,
  images: {},
  isCanceled: false,
  contractSought: {},
  signerRole: {},
  persistedPageSize: 10,
  persistedPage: 1,
  activeTab: 0,
  startDate: '',
  endDate: '',
  activeTabWithFilter: '',
  isUpdated: STATUS.PENDING,
  isSaved: STATUS.PENDING,
  notifications: [],
  sourceUrl: sessionStorage.getItem('sourceUrl'),
  docPrice: 32990,
  editSpinner: false,
  domainCert: '',
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case SET_EDIT_SPINNER:
      return { ...state, editSpinner: payload };
    case NOTIFICATION_CONTRACT_DATA:
      return { ...state, notifications: payload };
    case SET_DOC_PRICE:
      return { ...state, docPrice: payload };
    case SOURCE_URL:
      sessionStorage.setItem('sourceUrl', payload);
      return { ...state, sourceUrl: payload };
    case DRAFT_DATA:
      if (payload !== null) {
        var draftData = Schema.rentContract.formParse(payload, true);
        return { ...state, 
          contractFormData: draftData, 
          previewData: { ...draftData }, 
          sourceUrl: draftData.sourceUrl 
        };
      }
      break;
    case DRAFT_IS_SAVED:
      return { ...state, isSaved: payload };
    case PDF_MODIFIED:
      return { ...state, isUpdated: payload };
    case PERSIST_DATE_FILTER:
      return { ...state, startDate: payload.startDate, endDate: payload.endDate, activeTabWithFilter: payload.activeState };
    case PERSIST_ACTIVE_TAB:
      return { ...state, activeTab: payload };
    case PERSIST_PAGESIZE:
      return { ...state, persistedPageSize: payload.selectedPageSize, persistedPage: payload.page };
    case SIGNER_ROLE:
      return { ...state, signerRole: payload };
    case SET_PREVIEW_DATA:
      return { ...state, previewData: payload };
    case CONTRACT_ID:
      return { ...state, contractId: payload };
    case CONTRACT_LIST_AWAITING_VALIDATION:
      return { ...state, awaitingValidation: payload };
    case CONTRACT_DATA:
      return { ...state, contractSought: payload };
    case SAVE_IMAGES_FROM:
      return { ...state, images: payload };
    case IS_SENT_NOTARISA:
      return { ...state, contractIsSent: payload };
    case FAILURE:
      return { ...state, operationFailure: payload };
    case CONTRACT_FORM_DATA:
      return { ...state, contractFormData: payload };
    case TOKEN_STATUS:
      return { ...state, tokenStatus: payload };
    case CONTRACT_LIST_CREATED:
      return {
        ...state,
        createdDocList: payload,
      };
    case CONTRACT_LIST_AWAITING_SIGN:
      return {
        ...state,
        awaitingSignDocList: payload,
      };
    case CONTRACT_LIST_SENDED:
      return {
        ...state,
        sendedDocList: payload,
      };
    case CONTRACT_LIST_VALIDATE:
      return {
        ...state,
        validateForAll: payload,
      };
    case CONTRACT_IS_CREATED:
      return {
        ...state,
        isCreated: payload,
      };
    case CONTRACT_IS_CANCELED:
      return {
        ...state,
        isCanceled: payload,
      };
    case CONTRACT_LIST_AWAITING_NOTARY:
      return {
        ...state,
        awaitingNotary: payload,
      };
    case CONTRACT_LIST_FINALIZED:
      return {
        ...state,
        finalizedDocList: payload,
      };
    case CONTRACT_LIST_CANCELED:
      return {
        ...state,
        canceledDocList: payload,
      };
    case CONTRACT_LIST_OBJECTED:
      return {
        ...state,
        objectedDocList: payload,
      };
    case CONTRACT_LIST_ALL:
      return {
        ...state,
        allDocList: payload,
      };
    case CONTRACT_LIST_LOADED:
      return {
        ...state,
        listIsLoaded: payload,
      };
    case RESET_IS_LOADED:
      return {
        ...state,
        isLoaded: false,
      };
    case CONTRACT_IS_LOADED:
      return {
        ...state,
        isLoaded: payload,
      };
    case OBJECT_IS_REJECTED:
      return {
        ...state,
        objIsRejected: payload,
      };
    case OBJECT_REJECTED_FAIL:
      return {
        ...state,
        objRejectedFail: payload,
      };
    case CONTRACT_PFD:
      return { ...state, contractPdf: payload };
    case CONTRACT_IS_SIGNED:
      return { ...state, contractIsSigned: payload };
    case CONTRACT_IS_DEMUR:
      return { ...state, contractIsDemur: payload };
    case CONTRACT_FORM_FETCH:
      var parsedData = Schema.rentContract.formParse(payload);
      return {
        ...state,
        contract: payload,
        contractFormData: parsedData,
        previewData: parsedData,
        isLoaded: true
      };
    case DOMAIN_CERT:
      return { ...state, domainCert: payload.substring(payload.indexOf(';') + 1) };
    default:
      return state;
  }
};